"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forgotPasswordMutation = void 0;
const client_1 = require("@apollo/client");
exports.forgotPasswordMutation = client_1.gql `
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      __typename
      ok
    }
  }
`;
//# sourceMappingURL=forgotPassword.js.map